module.exports = __webpack_public_path__ + "img/logo-sm.4b8d2e16.png";